import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import SubItem from '../TraditionalUPS/SubItem';
import BtnWithWin from './BtnWithWin';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function TheComp() {
    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.NonstopPower');

    const imgs = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1732326118522/NonstopPower-pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1732326118716/NonstopPower-h5.jpg',
    };

    const list = [
        {
            text: t('bar1_text'),
            count: t('bar1_count'),
        },
        {
            text: t('bar2_text'),
            count: t('bar2_count'),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <SubItem className="NonstopPower-item" title={t('subItem1_title')} imgs={imgs} list={list} />
            <BtnWithWin />
            <EfSpec />
        </div>
    );
}
